
const RefundPolicy = () => {
  return (
    <>
        <title>IOPS SPACE Refund Policy</title>
      <div className="p-8 max-w-4xl mx-auto bg-white">
        <h1 className="text-3xl font-bold mb-6">Refund Policy</h1>
        
        <nav className="mb-8">
          <ul className="list-disc pl-5">
            <li><a href="#basic-policy" className="text-blue-600 hover:underline">A. Basic Refund Policy</a></li>
            <li><a href="#guidelines" className="text-blue-600 hover:underline">B. Refund Guidelines</a></li>
            <li><a href="#non-refundable" className="text-blue-600 hover:underline">C. Non-refundable Conditions</a></li>
            <li><a href="#company-responsibility" className="text-blue-600 hover:underline">D. Company&apos;s Responsibility</a></li>
            <li><a href="#member-responsibility" className="text-blue-600 hover:underline">E. Member&apos;s Responsibility</a></li>
          </ul>
        </nav>

        <section id="basic-policy" className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">A. Basic Refund Policy</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>Members can request a refund within the withdrawal period (1 days before the scheduled communication session) after subscribing to a paid service.</li>
            <li>Refunds are only possible if there is no usage of the service, content download, or data transmission within the withdrawal period.</li>
            <li>Refunds are not possible if the withdrawal period has passed or if the request falls under conditions that are non-refundable, such as communication sessions requested on the day of the session.</li>
          </ul>
        </section>

        <section id="guidelines" className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">B. Refund Guidelines</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>Refund requests within the withdrawal period: Full refund</li>
            <li>Requests for communication sessions on the day of the session or other non-refundable conditions: No refund</li>
            <li>In case of overpayment or underpayment: If the overpayment is due to the member&apos;s mistake and not the company&apos;s fault, the member may be charged a refund processing fee.</li>
          </ul>
        </section>

        <section id="non-refundable" className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">C. Non-refundable Conditions</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>If the service has been used, data has been downloaded, or the communication profile was incorrectly filled out during the withdrawal period, making the service impossible to provide normally.</li>
            <li>If data provided by the company has been transmitted to the member.</li>
            <li>Communication sessions requested on the day of the session.</li>
            <li>If service cancellation was requested without prior consultation with the company.</li>
          </ul>
        </section>

        <section id="company-responsibility" className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">D. Company&apos;s Responsibility</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>If the company experiences technical issues or operational errors that prevent the service from being provided, a full refund will be given.</li>
            <li>Refunds will be processed according to the member&apos;s request, as long as it does not violate the service terms and conditions.</li>
          </ul>
        </section>

        <section id="member-responsibility" className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">E. Member&apos;s Responsibility</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>Refunds are not possible due to simple change of mind or negligence on the member&apos;s part that makes it impossible to use the service.</li>
            <li>Any damages caused by the member&apos;s fault during service use may fall under the non-refundable conditions.</li>
          </ul>
        </section>

        <footer className="mt-12 pt-4 border-t border-gray-300 text-sm text-gray-600">
          <p>For any questions regarding our refund policy, please contact our customer support.</p>
          <p>Customer Inquiry Email: <a href="mailto:iopsspace@i-ops.co.kr" className="text-blue-600 hover:underline">iopsspace@i-ops.co.kr</a></p>
          <p>Last updated: 2024-11-12</p>
        </footer>
      </div>
    </>
  );
};

export default RefundPolicy;
